export const knownAmount = (value:unknown):boolean => value != null && String(value).trim() !== '' && Number.isFinite(Number(value)) && Number(value) >= 0;
export function paymentStatus(note:any, payments:any[], proofs:any[]):string {
 if (!knownAmount(note?.balance)) return 'Solde à confirmer';
 if (Number(note.balance) === 0) return 'Payée';
 if (proofs.some(p => ['PENDING','SUBMITTED'].includes(p.status))) return 'Preuve soumise — en attente de validation ONT';
 if (payments.some(p => ['INITIATED','PENDING','PROCESSING'].includes(p.status))) return 'Paiement en cours';
 return knownAmount(note.paid) && Number(note.paid)>0 ? 'Paiement partiel' : 'À payer';
}
export function paymentLimit(note:any,currency:string):number|null {
 if (!knownAmount(note?.balance) || !['USD','CDF'].includes(currency) || !['USD','CDF'].includes(note?.currency)) return null;
 if (currency === note.currency) return Number(note.balance);
 if (!knownAmount(note.exchange_rate) || Number(note.exchange_rate)<=0) return null;
 return Number(note.balance) * (currency==='CDF' ? Number(note.exchange_rate) : 1/Number(note.exchange_rate));
}
export function validPaymentAmount(value:string, maximum:number|null):boolean {
 return /^(0|[1-9]\d{0,12})(\.\d{1,2})?$/.test(value) && Number(value)>0 && maximum!==null && Number(value)<=maximum;
}
export function secureCheckoutURL(value:unknown):boolean {
 try {const url=new URL(String(value));return url.protocol==='https:' && !url.username && !url.password;} catch {return false;}
}
